<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">门店折扣<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>店铺名称</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
            </div>
            <div class="content-input-item">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">

            </div>
          </div>
<!--          <div class="content-input-item">-->
<!--            <label>状态：</label>-->
<!--            <el-select v-model="state" placeholder="Select" style="width: 6.4em">-->
<!--              <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <!--          <div class="content-input-item">-->
          <!--            <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
          <!--          </div>-->

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
<!--            <el-button type="primary" @click="editShopDialog(-1)" size="default">添加门店</el-button>-->
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
              @cell-click="showEdit"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1"/>
            <el-table-column property="shopName" label="店铺名称" v-if="checkColList.indexOf('店铺名称') > -1"/>
            <el-table-column property="" label="500账户" v-if="checkColList.indexOf('500账户') > -1" class-name="cursor">
              <template #default="scope">
                <p v-if="!scope.row.show1">{{ scope.row.wallet1 }}</p>
                <el-input type="number" :max="10" :min="0" v-else v-model="scope.row.wallet1" @focusout="submit(scope.row, 1)"><template #suffix>折</template></el-input>
              </template>
            </el-table-column>
            <el-table-column property="name" label="1000账户" v-if="checkColList.indexOf('1000账户') > -1" class-name="cursor">
              <template #default="scope">
                <p v-if="!scope.row.show2">{{ scope.row.wallet2 }}</p>
                <el-input type="number" :max="10" :min="0" v-else v-model="scope.row.wallet2" @focusout="submit(scope.row, 2)"><template #suffix>折</template></el-input>
              </template>
            </el-table-column>
            <el-table-column property="name" label="1500账户" v-if="checkColList.indexOf('1500账户') > -1" class-name="cursor">
              <template #default="scope">
                <p v-if="!scope.row.show3">{{ scope.row.wallet3 }}</p>
                <el-input type="number" :max="10" :min="0" v-else v-model="scope.row.wallet3" @focusout="submit(scope.row, 3)"><template #suffix>折</template></el-input>
              </template>
            </el-table-column>
            <el-table-column property="name" label="2500账户" v-if="checkColList.indexOf('2500账户') > -1" class-name="cursor">
              <template #default="scope">
                <p v-if="!scope.row.show4">{{ scope.row.wallet4 }}</p>
                <el-input type="number" :max="10" :min="0" v-else v-model="scope.row.wallet4" @focusout="submit(scope.row, 4)"><template #suffix>折</template></el-input>
              </template>
            </el-table-column>
<!--            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">-->
<!--              <template #default="scope">-->
<!--                <el-button @click="editShopPriceDialog(scope.row)" size="small" type="text">编辑价格表</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getShopDiscountPageList, updateShopDiscount} from "@/api/url";
// import shopDiscountDialog from "@/views/shop/components/shopDiscountDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import {negativeDecimal} from "@/assets/shared/reg-constant";

export default {
  name: "ShopDiscount",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['更新时间', '店铺名称', '500账户', '1000账户', '1500账户', '2500账户'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '店铺名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopDiscountPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.forEach(item => {
            item.wallet1 = Math.floor(item.walletOne * 100) / 10
            item.wallet2 = Math.floor(item.walletTwo * 100) / 10
            item.wallet3 = Math.floor(item.walletThree * 100) / 10
            item.wallet4 = Math.floor(item.walletFour * 100) / 10
            item.show1 = false
            item.show2 = false
            item.show3 = false
            item.show4 = false
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editShopDialog(idx, row) {
      let _title = '';
      let shopForm = {}
      if (idx > -1) {
        _title = '编辑门店'
        shopForm = Object.assign({}, row);
        // console.log(shopForm)
      }else {
        _title = '添加门店'
        // console.log(shopForm)
      }
      Dialog.open({
        title: _title,
        component: shopDialog,
        data: {
          shopForm: shopForm,
          ids: idx,
          width: '500px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    // editShopPriceDialog(row) {
    //   Dialog.open({
    //     title:  '【' + row.shopName + '】的服务价格表',
    //     component: shopDiscountDialog,
    //     data: {
    //       id: row.id,
    //       width: '800px',
    //     },
    //     confirm: (result) => {
    //       this.getPage()
    //     }
    //   })
    // },


    showEdit(row, column, cell, event) {
      this.pageDataList.forEach(item => {
        item.show1 = false
        item.show2 = false
        item.show3 = false
        item.show4 = false
      })

      if(column.label == '500账户') {
          row.show1 = true
      }
      if(column.label == '1000账户') {
        row.show2 = true
      }
      if(column.label == '1500账户') {
        row.show3 = true
      }
      if(column.label == '2500账户') {
        row.show4 = true
      }
    },

    submit(item, type) {
      if(!item['wallet' + type]) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '折扣不能为空',
          type: 'warning'
        });
        item.wallet1 = Math.floor(item.walletOne * 100) / 10
        item.wallet2 = Math.floor(item.walletTwo * 100) / 10
        item.wallet3 = Math.floor(item.walletThree * 100) / 10
        item.wallet4 = Math.floor(item.walletFour * 100) / 10
        return false
      }else if(Number(item['wallet' + type]) > 10 || Number(item['wallet' + type]) < 0 ) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的折扣数',
          type: 'warning'
        });
        item.wallet1 = Math.floor(item.walletOne * 100) / 10
        item.wallet2 = Math.floor(item.walletTwo * 100) / 10
        item.wallet3 = Math.floor(item.walletThree * 100) / 10
        item.wallet4 = Math.floor(item.walletFour * 100) / 10
        return false
      }
      let param = {}
      param['id'] = item.id;
      switch (type) {
        case 1 :
          param['discount'] = Math.floor(item.wallet1 * 10) / 100
          break;
        case 2 :
          param['discount'] = Math.floor(item.wallet2 * 10) / 100
          break;
        case 3 :
          param['discount'] = Math.floor(item.wallet3 * 10) / 100
          break;
        case 4 :
          param['discount'] = Math.floor(item.wallet4 * 10) / 100
          break;
      }
      param['type'] = type
      postFormData(updateShopDiscount, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          item['show' + type] = false
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    // this.getShopList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
